module.exports = __webpack_public_path__ + "img/paragraph-spacing.679b56a8.svg";